export default "__VITE_ASSET__fef7a81d__"